/*
 * Asynchronously loads the component for NotAvailable
 */

import { lazyLoad } from 'utils/loadable';

export const NotAvailable = lazyLoad(
  () => import('./index'),
  module => module.NotAvailable,
);
